var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigmaDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.9,322.1c-56.9-34.2-58.3-109.6-1-144.5c-7.2-6.1-15.4-11.5-21.5-18.5c-21.7-24.9-27.2-53.6-14.6-84.2 c12.8-31.1,37.1-48.8,70.7-49.6c50.3-1.2,100.6-1,150.9-0.1c35.9,0.6,64.4,24,74.3,58.3c9.7,33.5-3.3,68.6-32.8,88.8 c-2.3,1.6-4.6,3.1-6.9,4.8c7.2,4.3,21,13.8,31.2,31.3c4,6.9,14.7,25.7,11.7,51c-0.5,4.2-3.4,24.1-19.3,42.6 c-26.6,31-80.8,44-125.1-1.7c0,12.3,0.2,22.9,0,33.4c-0.5,25.3,1.1,50.9-2.4,75.8c-5.1,36.5-35.4,61.7-72.4,64.7 c-35.5,2.9-69.1-18.7-81.4-52.1c-12.5-34-0.9-71.9,28.6-93.4C137.9,326.5,141,324.6,144.9,322.1z M245.2,41.2 c-23,0-44.7-1.1-66.3,0.3c-33.7,2.1-59,28.1-60.9,60.7c-1.8,30.3,20.5,61.4,51.2,65.2c24.8,3.1,50.3,0.6,76,0.6 C245.2,125.9,245.2,84.2,245.2,41.2z M263.1,168.8c23.1,0,44.8,0.5,66.5-0.1c31.4-0.8,57.1-25.9,60.6-58.1 c3.2-30-18.5-62.6-48.9-66.7c-25.5-3.4-51.8-0.7-78.2-0.7C263.1,84.2,263.1,125.8,263.1,168.8z M245.3,185.8 c-23.4,0-45.4-0.8-67.5,0.2c-31.4,1.3-56.8,27.1-59.7,59c-2.7,29.3,17.5,60.5,47.1,65.5c26.1,4.4,53.1,3,80.1,4.2 C245.3,270.4,245.3,228.7,245.3,185.8z M245.6,330.5c-23.6,0-46-0.6-68.4,0.2c-32.8,1.2-59.9,30.9-59.4,64.2 c0.5,34.2,29.1,62.7,63.4,63.3c32.8,0.6,63-26.9,64.2-59.5C246.3,376.6,245.6,354.5,245.6,330.5z M326.7,185.7 c-34.9-0.1-63.9,28.5-64.1,63.3c-0.2,35.1,28.1,64.2,62.9,64.6c35.2,0.4,64.7-28.6,64.9-64C390.6,215.3,361.2,185.8,326.7,185.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaDark);
export default __webpack_public_path__ + "static/media/figma_dark.d74ca490ec1767c7e78f9ff502160e8e.svg";
export { ForwardRef as ReactComponent };